<template>
    <div id="app">
        <transition
            name="fade"
            mode="out-in"
        >
            <router-view />
        </transition>
    </div>
</template>

<script>
import { WECHAT_BROWSER } from "./untils/browser.js";
export default {
    name: "App",
    watch: {
        $route: {
            immediate: true,
            deep: true,
            handler(to, from) {
                if (!WECHAT_BROWSER) return;
                // 不会刷新浏览器，只是让微信浏览器同步当前url
                // eslint-disable-next-line
                window.location.href = window.location.href;
            }
        }
    }
};
</script>

<style>
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.fade-enter {
    /* transform: translateX(100%) */
    /* opacity: 1; */
}
.fade-leave {
    /* opacity: 1; */
    /* transform: translateX(0) */
}
.fade-enter-active {
    /* transition: translateX 0.3s; */
}
.fade-leave-active {
    /* transform: translateX(100%); */
    /* transition: opacity 0.3s; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue